import React, { useState, useEffect } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { Search } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Wishlists = () => {
  const [wishlists, setWishlists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchWishlists();
  }, []);

  const fetchWishlists = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/wishlists`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        setWishlists(data);
      }
    } catch (error) {
      console.error('Failed to fetch wishlists:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredWishlists = wishlists.filter(wishlist => {
    const userName = wishlist.user?.name || '';
    const userEmail = wishlist.user?.email || '';
    return userName.toLowerCase().includes(search.toLowerCase()) ||
           userEmail.toLowerCase().includes(search.toLowerCase());
  });

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Wishlists</h1>
          <p className="text-gray-600 dark:text-gray-400">View user wishlists</p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            <input
              type="text"
              placeholder="Search by user..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
            />
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 dark:bg-gray-900">
                <tr>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">User</th>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">Products</th>
                  <th className="text-left py-3 px-4 text-gray-600 dark:text-gray-400">Created</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center py-8 text-gray-500">Loading...</td>
                  </tr>
                ) : filteredWishlists.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center py-8 text-gray-500">No wishlists found</td>
                  </tr>
                ) : (
                  filteredWishlists.map((wishlist) => (
                    <tr key={wishlist.id} className="border-t dark:border-gray-700">
                      <td className="py-3 px-4">
                        <div className="text-gray-900 dark:text-white">{wishlist.user?.name}</div>
                        <div className="text-sm text-gray-500">{wishlist.user?.email}</div>
                      </td>
                      <td className="py-3 px-4 text-gray-600 dark:text-gray-400">
                        {wishlist.products?.length || 0} items
                      </td>
                      <td className="py-3 px-4 text-gray-600 dark:text-gray-400">
                        {new Date(wishlist.created_at).toLocaleDateString()}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Wishlists;